import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import Location from "../../assets/images/location.svg";
import Leash from "../../assets/images/leash.svg";
import Home from "../../assets/images/home.svg";
import Sun from "../../assets/images/sun.svg";
import Bowl from "../../assets/images/bowl.svg";
import services_hero from "../../assets/images/services_hero.png";
import servies_one from "../../assets/images/servies_one.png";
import servies_two from "../../assets/images/servies_two.png";
import servies_tree from "../../assets/images/servies_tree.png";

const Services: React.FC = () => {
  const services = [
    {
      icon: <img src={Location} alt="location" width="54px" height="54px" />,
      title: "Boarding:",
      description:
        "Give your pets a comfortable and home-like experience by letting them stay overnight in the caring environment of your sitter's home.",
    },
    {
      icon: <img src={Leash} alt="Leash" width="54px" height="54px" />,
      title: "Dog Walking:",
      description:
        "Keep your dog active and happy with neighborhood walks provided by a dedicated dog walker. Ideal for busy days or for dogs with excess energy.",
    },
    {
      icon: <img src={Home} alt="Home" width="54px" height="54px" />,
      title: "House Sitting:",
      description:
        "Ensure both your pets and your home are well taken care of by a trusted sitter. Your pets can stay in the familiar surroundings of their own home while receiving personalized care and attention from the sitter.",
    },
    {
      icon: <img src={Sun} alt="Sun" width="54px" height="54px" />,
      title: "Doggy Day Care:",
      description:
        "Give your dog an enriching and fun-filled day by sending them to the sitter's home for doggy day care. Drop them off in the morning and pick up a content and happy pup in the evening.",
    },
    {
      icon: <img src={Bowl} alt="Bowl" width="54px" height="54px" />,
      title: "Drop-In Visits:",
      description:
        "Allow your pets to stay in the comfort of their own home while a sitter drops by to provide playtime, feed them, offer potty breaks, or take care of litter box cleaning.",
    },
  ];

  const bookingFeatures = [
    {
      text: "Seamlessly book pet sitting services based on your specific needs, including dates, times, and desired services, ensuring a convenient and reliable arrangement for your furry friends.",
      image: servies_one,
      imagePosition: "left",
    },
    {
      text: "Stay informed with real-time updates, including photos, videos, and messages from the pet sitter during their visits, offering you peace of mind and a connection with your pets while you're away.",
      image: servies_two,
      imagePosition: "right",
    },
    {
      text: "Enjoy a secure and hassle-free payment system to handle transactions with pet sitters, making the process convenient and reliable.",
      image: servies_tree,
      imagePosition: "left",
    },
  ];

  return (
    <Box sx={{ backgroundColor: "#FAF8F5", minHeight: "100vh" }}>
      {/* Hero Section */}
      <Container maxWidth="lg" sx={{ pt: 8, pb: 6 }}>
        <Typography
          variant="h2"
          align="center"
          sx={{
            fontSize: { xs: "2rem", md: "2.5rem" },
            fontWeight: 700,
            color: "#178B8E",
            mb: 8,
          }}
        >
          Connecting Pet Owners with Reliable Sitters
        </Typography>
      </Container>

      {/* Services Grid with Image */}
      <Container maxWidth="lg" sx={{ pb: 10 }}>
        <Grid container spacing={6} alignItems="center">
          {/* Services List */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
              {services.map((service, index) => (
                <Box key={index} sx={{ display: "flex", gap: 2 }}>
                  <Box sx={{ flexShrink: 0 }}>{service.icon}</Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#178B8E",
                        fontWeight: 600,
                        mb: 1,
                      }}
                    >
                      {service.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#5A5A5A",
                        lineHeight: 1.7,
                      }}
                    >
                      {service.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Image with Yellow Circle Background */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  width: { xs: "100%", sm: "350px", md: "400px" },
                  height: { xs: "auto", sm: "500px", md: "600px" },
                  maxHeight: { xs: 480 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <Box
                  component="img"
                  src={services_hero}
                  alt="Woman with dog"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    display: "block",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ backgroundColor: "#FFFFFF", py: 10 }}>
        <Container maxWidth="lg">
          {bookingFeatures.map((feature, index) => (
            <Grid
              container
              spacing={6}
              alignItems="center"
              key={index}
              sx={{ mb: index < bookingFeatures.length - 1 ? 8 : 0 }}
              direction={
                feature.imagePosition === "right" ? "row-reverse" : "row"
              }
            >
              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    width: "100%",
                    height: 300,
                    backgroundColor:
                      index === 0
                        ? "#E8F5F5"
                        : index === 1
                          ? "#FFF5E0"
                          : "#FFE8E8",
                    borderRadius: "50% 50% 50% 50% / 60% 60% 40% 40%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={feature.image}
                    alt={`Feature ${index + 1}`}
                    style={{
                      width: "80%",
                      height: "80%",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: "1.2rem",
                    color: "#178B8E",
                    lineHeight: 1.8,
                    fontWeight: 500,
                  }}
                >
                  {feature.text}
                </Typography>
              </Grid>
            </Grid>
          ))}
        </Container>
      </Box>
    </Box>
  );
};

export default Services;
